import React from 'react';
import '../template-file-css/document-file-template.css';


export const OABS_PsychiatricEvaluation = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='OABS_PsychiatricEvaluation' className='file-pdf-document'>

            <div className='file-template'>
 

                <p className='w-750'><h3>INITIAL PSYCHIATRIC EVALUATION</h3></p>


                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Individual Accompany by: </span></td>
                        <td className='w-375'><span className='eleHeader'>Relationship: </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtIndividualAccompany' name='txtIndividualAccompany' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtRelationship' name='txtRelationship' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Method of Visit:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbMethodVisitFace' name='rbMethodVisit' className='add-only' value='FaceToFace' /> Face to Face &nbsp;
                            <input type='radio' id='rbMethodVisitTelephonic' name='rbMethodVisit' className='add-only' value='Telephonic' /> Telehealth/Telephonic
                        </td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>Location of Visit:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbLocationVisitOffice' name='rbLocationVisit' className='add-only' value='Office' /> Office &nbsp;
                            <input type='radio' id='rbLocationVisitHome' name='rbLocationVisit' className='add-only' value='Home' /> Home &nbsp;
                            <input type='radio' id='rbLocationVisitOther' name='rbLocationVisit' className='add-only' value='Other' /> Other
                        </td>
                    </tr>


                    <tr>
                        <td className='w-250'><span className='eleHeader'>(Vitals) B/P:  </span></td>
                        <td className='w-250'><span className='eleHeader'>Pulse </span></td>
                        <td className='w-250'><span className='eleHeader'>Weight </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtVitals' name='txtVitals' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtPulse' name='txtPulse' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtWeight' name='txtWeight' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>REASON FOR REFERRAL AND CHIEF COMPLAINT:</span></p>
                <p className='w-750'>
                    <textarea id='txtReasonForReferral' name='txtReasonForReferral' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>PRESENTING PROBLEM:</span></p>
                <p className='w-750'>
                    <textarea id='txtPresentingProblems' name='txtPresentingProblems' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>HISTORY OF PRESENT ILLNESS:</span></p>
                <p className='w-750'>
                    <textarea id='txtPresentIlleness' name='txtPresentIlleness' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>HISTORY OF SYMPTOMS: BEHAVIORAL/EMOTIONAL STATUS (Individual)</span>
                            <span className='small'>Check all of following that is typical:</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAggressive' name='cbAggressive' className='add-only' value='Aggressive' /> Aggressive</td>
                        <td className='w-250'><input type='checkbox' id='cbSadCrying' name='cbSadCrying' className='add-only' value='SadCrying' /> Sad/Crying </td>
                        <td className='w-250'><input type='checkbox' id='cbTruancy' name='cbTruancy' className='add-only' value='Truancy' /> Truancy</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbMoodSwings' name='cbMoodSwings' className='add-only' value='MoodSwings' /> Mood Swings </td>
                        <td className='w-250'><input type='checkbox' id='cbAngry' name='cbAngry' className='add-only' value='Angry' /> Angry</td>
                        <td className='w-250'><input type='checkbox' id='cbAnxiety' name='cbAnxiety' className='add-only' value='Anxiety' /> Anxiety</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbHallucinations' name='cbHallucinations' className='add-only' value='Hallucinations' /> Hallucinations</td>
                        <td className='w-250'><input type='checkbox' id='cbHeadBanging' name='cbHeadBanging' className='add-only' value='HeadBanging' /> Head Banging </td>
                        <td className='w-250'><input type='checkbox' id='cbFearful' name='cbFearful' className='add-only' value='Fearful' /> Fearful</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPtsd' name='cbPtsd' className='add-only' value='Ptsd' /> PTSD</td>
                        <td className='w-250'><input type='checkbox' id='cbLiesFrequently' name='cbLiesFrequently' className='add-only' value='LiesFrequently' /> Lies frequently</td>
                        <td className='w-250'><input type='checkbox' id='cbSetFires' name='cbSetFires' className='add-only' value='SetFires' /> Set fires</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbHurtsAnimals' name='cbHurtsAnimals' className='add-only' value='HurtsAnimals' /> Hurts animals</td>
                        <td className='w-250'><input type='checkbox' id='cbAvoidsAdults' name='cbAvoidsAdults' className='add-only' value='AvoidsAdults' /> Avoids adults</td>
                        <td className='w-250'><input type='checkbox' id='cbLoner' name='cbLoner' className='add-only' value='Loner' /> Loner</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbImpulsive' name='cbImpulsive' className='add-only' value='Impulsive' /> Impulsive</td>
                        <td className='w-250'><input type='checkbox' id='cbImaginaryFriends' name='cbImaginaryFriends' className='add-only' value='ImaginaryFriends' /> Imaginary friends</td>
                        <td className='w-250'><input type='checkbox' id='cbSexualActingOut' name='cbSexualActingOut' className='add-only' value='SexualActingOut' /> Sexual acting out</td>
                    </tr>
                    <tr>

                        <td className='w-250'><input type='checkbox' id='cbBedwetting' name='cbBedwetting' className='add-only' value='Bedwetting' /> Bedwetting</td>
                        <td className='w-250'><input type='checkbox' id='cbShortAttentionSpan' name='cbShortAttentionSpan' className='add-only' value='ShortAttentionSpan' /> Short attention span</td>
                        <td className='w-250'><input type='checkbox' id='cbBizarreBehavior' name='cbBizarreBehavior' className='add-only' value='BizarreBehavior' /> Bizarre Behavior</td>

                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbIrritable' name='cbIrritable' className='add-only' value='Irritable' /> Irritable</td>
                        <td className='w-250'><input type='checkbox' id='cbRunningAway' name='cbRunningAway' className='add-only' value='RunningAway' /> Running away</td>
                        <td className='w-250'><input type='checkbox' id='cbHygieneAdl' name='cbHygieneAdl' className='add-only' value='HygieneAdl' /> Hygiene/ADL's</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSpeechProblems' name='cbSpeechProblems' className='add-only' value='SpeechProblems' /> Speech problems</td>
                        <td className='w-250'><input type='checkbox' id='cbCarelessReckless' name='cbCarelessReckless' className='add-only' value='CarelessReckless' /> Careless, reckless</td>
                        <td className='w-250'><input type='checkbox' id='cbBulliesThreatens' name='cbBulliesThreatens' className='add-only' value='BulliesThreatens' /> Bullies, threatens
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbLearningProblems' name='cbLearningProblems' className='add-only' value='LearningProblems' /> Learning problems</td>
                        <td className='w-250'><input type='checkbox' id='cbSteals' name='cbSteals' className='add-only' value='Steals' /> Steals</td>
                        <td className='w-250'><input type='checkbox' id='cbSuicidalThreats' name='cbSuicidalThreats' className='add-only' value='SuicidalThreats' /> Suicidal threats</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbLowSelfesteem' name='cbLowSelfesteem' className='add-only' value='LowSelfesteem' /> Low self-esteem</td>
                        <td className='w-250'><input type='checkbox' id='cbHyperactivity' name='cbHyperactivity' className='add-only' value='Hyperactivity' /> Hyperactivity</td>
                        <td className='w-250'><input type='checkbox' id='cbTalkBack' name='cbTalkBack' className='add-only' value='TalkBack' /> Talk back</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbImpulseContro' name='cbImpulseContro' className='add-only' value='ImpulseContro' /> Impulse contro</td>
                        <td className='w-250'><input type='checkbox' id='cbNightmares' name='cbNightmares' className='add-only' value='Nightmares' /> Nightmares</td>
                        <td className='w-250'><input type='checkbox' id='cbDefiant' name='cbDefiant' className='add-only' value='Defiant' /> Defiant</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDestructive' name='cbDestructive' className='add-only' value='Destructive' /> Destructive</td>
                        <td className='w-250'><input type='checkbox' id='cbOppositional' name='cbOppositional' className='add-only' value='Oppositional' /> Oppositional</td>
                        <td className='w-250'><input type='checkbox' id='cbPanicAttacks' name='cbPanicAttacks' className='add-only' value='PanicAttacks' /> Panic attacks</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDrugDependence' name='cbDrugDependence' className='add-only' value='DrugDependence' /> Drug(s) dependence</td>
                        <td className='w-250'><input type='checkbox' id='cbPhobias' name='cbPhobias' className='add-only' value='Phobias' /> Phobias</td>
                        <td className='w-250'><input type='checkbox' id='cbLossInterests' name='cbLossInterests' className='add-only' value='LossInterests' /> Loss of energy/Interests</td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbFrustratedEasily' name='cbFrustratedEasily' className='add-only' value='FrustratedEasily' /> Frustrated easily</td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOtherConcerns' name='cbOtherConcerns' className='add-only' value='OtherConcerns' /> Other Concerns (Specify):
                            <input type='text' id='txtOtherConcerns' name='txtOtherConcerns' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Current Psychiatric Medications:</span></p>
                <p className='w-750'>
                    <textarea id='txtCurrentPsychiatricMedications' name='txtCurrentPsychiatricMedications' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <h3>Medication Education:</h3></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Verbal Medication Consent:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbVerbalMedicationConsentYes' name='rbVerbalMedicationConsent' className='add-only' value='Yes' /> YES &nbsp;
                            <input type='radio' id='rbVerbalMedicationConsentNo' name='rbVerbalMedicationConsent' className='add-only' value='No' /> NO &nbsp;
                            <input type='radio' id='rbVerbalMedicationConsentNa' name='rbVerbalMedicationConsent' className='add-only' value='Na' /> N/A
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbVerbalMedicationConsentNameMedication' name='cbVerbalMedicationConsentNameMedication' className='add-only' value='NameMedication' /> Name of medication(s), reason for prescribing, how to administer/take, time, frequency, amount & route &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbVerbalMedicationConsentSideEffect' name='cbVerbalMedicationConsentSideEffect' className='add-only' value='SideEffect' /> Side Effects/Benefits/Adverse Reaction &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbVerbalMedicationConsentUseOfAlcohol' name='cbVerbalMedicationConsentUseOfAlcohol' className='add-only' value='UseOfAlcohol' /> Use of Alcohol/drug/tobacco interaction &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbVerbalMedicationConsentCompliance' name='cbVerbalMedicationConsentCompliance' className='add-only' value='Compliance' /> Compliance/Non-Compliance &nbsp;
                        </td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'> OTC Medication(s):</span></td>
                        <td className='w-250'><span className='eleHeader'> Appetite:</span></td>
                        <td className='w-250'><span className='eleHeader'> Sleeping Patterns:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtOtcMedication' name='txtOtcMedication' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtAppetite' name='txtAppetite' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtSleepingPatterns' name='txtSleepingPatterns' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'> Motivation:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtMotivation' name='txtMotivation' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Special Diet/Dietary Restrictions:</span></p>
                <p className='w-750'>
                    <textarea id='txtSpecialDiet' name='txtSpecialDiet' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbChildBearing' name='cbChildBearing' className='add-only' value='ChildBearing' /> Child bearing/pregnancy, if NOT applicable indicate:
                    <input type='text' id='txtChildBearing' name='txtChildBearing' className='add-only w-250 custom-add-only' />
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbChildBearingNa' name='cbChildBearingNa' className='add-only' value='Na' /> N/A
                </p>

                <p className='w-750'><span className='eleHeader'>PSYCHIATRIC HISTORY:</span></p>
                <p className='w-750'>
                    <textarea id='txtPsychiatricHistory' name='txtPsychiatricHistory' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>SIGNIFICANT PERSONAL, FAMILY, & SOCIAL HISTORY:</span></p>
                <p className='w-750'>
                    <textarea id='txtSignificantPersonalHistory' name='txtSignificantPersonalHistory' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>FAMILY PSYCHIATRIC AND MEDICAL/SURGICAL HISTORY:</span></p>
                <p className='w-750'>
                    <textarea id='txtFamilyPsychiatricHistory' name='txtFamilyPsychiatricHistory' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>FX HX:</span></p>
                <p className='w-750'>
                    <textarea id='txtFxHx' name='txtFxHx' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>MEDICAL HX/DIAGNOSIS/SURGERY HX:</span></p>
                <p className='w-750'>
                    <textarea id='txtMedicalHx' name='txtMedicalHx' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Current Physical Medications:</span></p>
                <p className='w-750'>
                    <textarea id='txtCurrentPhysicalMedications' name='txtCurrentPhysicalMedications' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Allergies:</span></p>
                <p className='w-750'>
                    <textarea id='txtAllergies' name='txtAllergies' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>SUBSTANCE USE HISTORY:</span></p>
                <p className='w-750'> Substance use/abuse history:
                    <input type='radio' id='rbSubstanceUseNoneReported' name='rbSubstanceUse' className='add-only' value='NoneReported' /> None reported &nbsp;
                    <input type='radio' id='rbSubstanceUseHistoryReported' name='rbSubstanceUse' className='add-only' value='HistoryReported' /> History Reported
                </p>
                <p className='w-750'>If yes specify:<input type='text' id='txtChildBearing_2' name='txtChildBearing_2' className='add-only w-350 custom-add-only' /></p>


                <p className='w-750'><span className='eleHeader'>LEGAL STATUS/HISTORY:</span></p>
                <p className='w-750'>
                    <textarea id='txtLegalStatusHistory' name='txtLegalStatusHistory' className='add-only'></textarea>
                </p>
                <p className='w-750'><span className='eleHeader'>EMPLOYMENT STATUS/HISTORY:</span></p>
                <p className='w-750'>
                    <textarea id='txtEmployementStatusHistory' name='txtEmployementStatusHistory' className='add-only'></textarea>
                </p>
                <p className='w-750'><span className='eleHeader'>EDUCATIONAL STATUS/HISTORY:</span></p>
                <p className='w-750'>
                    <textarea id='txtEducationalStatusHistory' name='txtEducationalStatusHistory' className='add-only'></textarea>
                </p>
                <p className='w-750'><span className='eleHeader'>HOUSING STATUS/HISTORY:</span></p>
                <p className='w-750'>
                    <textarea id='txtHousingStatusHistory' name='txtHousingStatusHistory' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <h3>(MENTAL STATUS EXAMINATION):</h3>
                    
                    </p>

                <p className='w-750'>
                    
                <h4> 1. MENTAL STATUS EXAMINATION <span className='small'>(Circle or Check all that apply.)</span></h4></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>a. GENERAL APPEARANCE</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbHealthy' name='cbHealthy' className='add-only' value='Healthy' /> Healthy</td>
                        <td className='w-250'><input type='checkbox' id='cbAsStatedAge' name='cbAsStatedAge' className='add-only' value='AsStatedAge' /> As stated Age</td>
                        <td className='w-250'><input type='checkbox' id='cbOlderThanStatedAge' name='cbOlderThanStatedAge' className='add-only' value='OlderThanStatedAge' /> Older Than Stated Age</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbYoungLooking' name='cbYoungLooking' className='add-only' value='YoungLooking' /> Young-Looking</td>
                        <td className='w-250'><input type='checkbox' id='cbTattoos' name='cbTattoos' className='add-only' value='Tattoos' /> Tattoos</td>
                        <td className='w-250'><input type='checkbox' id='cbDisheveled' name='cbDisheveled' className='add-only' value='Disheveled' /> Disheveled</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbUnkempt' name='cbUnkempt' className='add-only' value='Unkempt' /> Unkemp</td>
                        <td className='w-250'><input type='checkbox' id='cbMalodorous' name='cbMalodorous' className='add-only' value='Malodorous' /> Malodorous</td>
                        <td className='w-250'><input type='checkbox' id='cbThin' name='cbThin' className='add-only' value='Thin' /> Thin</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbOverwieght' name='cbOverwieght' className='add-only' value='Overwieght' /> Overwieght</td>
                        <td className='w-250'><input type='checkbox' id='cbObese' name='cbObese' className='add-only' value='Obese' /> Obese</td>

                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbGeneralAppearanceOtherDescribe' name='cbGeneralAppearanceOtherDescribe' className='add-only' value='OtherDescribe' /> Other/Describe:
                            <input type='text' id='txtGeneralAppearanceOtherDescribe' name='txtGeneralAppearanceOtherDescribe' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>b. BEHAVIOR & PSYCHOMOTOR ACTIVITY</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbNormal' name='cbNormal' className='add-only' value='Normal' /> Normal</td>
                        <td className='w-250'><input type='checkbox' id='cbOveractive' name='cbOveractive' className='add-only' value='Overactive' /> Overactive</td>
                        <td className='w-250'><input type='checkbox' id='cbHypoactive' name='cbHypoactive' className='add-only' value='Hypoactive' /> Hypoactive</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbCatatonia' name='cbCatatonia' className='add-only' value='Catatonia' /> Catatonia</td>
                        <td className='w-250'><input type='checkbox' id='cbTremor' name='cbTremor' className='add-only' value='Tremor' /> Tremor</td>
                        <td className='w-250'><input type='checkbox' id='cbTics' name='cbTics' className='add-only' value='Tics' /> Tics</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbCombative' name='cbCombative' className='add-only' value='Combative' /> Combative</td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbBehaviorActivityOtherDescribe' name='cbBehaviorActivityOtherDescribe' className='add-only' value='' /> Other/Describe:
                            <input type='text' id='txtBehaviorActivityOtherDescribe' name='txtBehaviorActivityOtherDescribe' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>c. ATTITUDE</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbOptimal' name='cbOptimal' className='add-only' value='Optimal' /> Optimal</td>
                        <td className='w-250'><input type='checkbox' id='cbConstructive' name='cbConstructive' className='add-only' value='Constructive' /> Constructive</td>
                        <td className='w-250'><input type='checkbox' id='cbMotivated' name='cbMotivated' className='add-only' value='Motivated' /> Motivated</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbObstructive' name='cbObstructive' className='add-only' value='Obstructive' /> Obstructive</td>
                        <td className='w-250'><input type='checkbox' id='cbAdversarial' name='cbAdversarial' className='add-only' value='Adversarial' /> Adversarial</td>
                        <td className='w-250'><input type='checkbox' id='cbInaccessible' name='cbInaccessible' className='add-only' value='Inaccessible' /> Inaccessible</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbCooperative' name='cbCooperative' className='add-only' value='Cooperative' /> Cooperative</td>
                        <td className='w-250'><input type='checkbox' id='cbSeductive' name='cbSeductive' className='add-only' value='Seductive' /> Seductive</td>
                        <td className='w-250'><input type='checkbox' id='cbDefensive' name='cbDefensive' className='add-only' value='Defensive' /> Defensive</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbHostile' name='cbHostile' className='add-only' value='Hostile' /> Hostile</td>
                        <td className='w-250'><input type='checkbox' id='cbGuarded' name='cbGuarded' className='add-only' value='Guarded' /> Guarded</td>
                        <td className='w-250'><input type='checkbox' id='cbApathetic' name='cbApathetic' className='add-only' value='Apathetic' /> Apathetic</td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbEvasive' name='cbEvasive' className='add-only' value='Evasive' /> Evasive</td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbAttitudeOtherDescribe' name='cbAttitudeOtherDescribe' className='add-only' value='' /> Other/Describe:
                            <input type='text' id='txtAttitudeOtherDescribe' name='txtAttitudeOtherDescribe' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>d. SPEECH</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSpeechNormal' name='cbSpeechNormal' className='add-only' value='Normal' /> Normal</td>
                        <td className='w-250'><input type='checkbox' id='cbSpeechSpontaneous' name='cbSpeechSpontaneous' className='add-only' value='Spontaneous' /> Spontaneous</td>
                        <td className='w-250'><input type='checkbox' id='cbSpeechSlow' name='cbSpeechSlow' className='add-only' value='Slow' /> Slow</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSpeechImpoverished' name='cbSpeechImpoverished' className='add-only' value='Impoverished' /> Impoverished</td>
                        <td className='w-250'><input type='checkbox' id='cbSpeechHesitant' name='cbSpeechHesitant' className='add-only' value='Hesitant' /> Hesitant</td>
                        <td className='w-250'><input type='checkbox' id='cbSpeechMonotonous' name='cbSpeechMonotonous' className='add-only' value='Monotonous' /> Monotonous</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSpeechEuphoric' name='cbSpeechSoftWhispered' className='add-only' value='SoftWhispered' /> Soft/Whispered</td>
                        <td className='w-250'><input type='checkbox' id='cbSpeechMumble' name='cbSpeechMumble' className='add-only' value='Mumble' /> Mumble</td>
                        <td className='w-250'><input type='checkbox' id='cbSpeechRapid' name='cbSpeechRapid' className='add-only' value='Rapid' /> Rapid</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSpeechPressured' name='cbSpeechPressured' className='add-only' value='Pressured' /> Pressured</td>
                        <td className='w-250'><input type='checkbox' id='cbSpeechVerbose' name='cbSpeechVerbose' className='add-only' value='Verbose' /> Verbose</td>
                        <td className='w-250'><input type='checkbox' id='cbSpeechLoud' name='cbSpeechLoud' className='add-only' value='Loud' /> Loud</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSpeechSlurred' name='cbSpeechSlurred' className='add-only' value='Slurred' /> Slurred</td>
                        <td className='w-250'><input type='checkbox' id='cbSpeechImpediment' name='cbSpeechImpediment' className='add-only' value='Impediment' /> Impediment</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSpeechOtherDescribe' name='cbSpeechOtherDescribe' className='add-only' value='OtherDescribe' /> Other/Describe:
                            <input type='text' id='txtAttitudeOtherDescribe_2' name='txtAttitudeOtherDescribe_2' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>e. MOOD</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbMoodDysphoric' name='cbMoodDysphoric' className='add-only' value='Dysphoric' /> Dysphoric</td>
                        <td className='w-250'><input type='checkbox' id='cbMoodEuthymic' name='cbMoodEuthymic' className='add-only' value='Euthymic' /> Euthymic</td>
                        <td className='w-250'><input type='checkbox' id='cbMoodExpansive' name='cbMoodExpansive' className='add-only' value='Expansive' /> Expansive</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbMoodIritable' name='cbMoodIritable' className='add-only' value='Iritable' /> Iritable</td>
                        <td className='w-250'><input type='checkbox' id='cbMoodLabile' name='cbMoodLabile' className='add-only' value='Labile' /> Labile</td>
                        <td className='w-250'><input type='checkbox' id='cbMoodElevated' name='cbMoodElevated' className='add-only' value='Elevated' /> Elevated</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbMoodEuphoric' name='cbMoodEuphoric' className='add-only' value='Euphoric' /> Euphoric</td>
                        <td className='w-250'><input type='checkbox' id='cbMoodEcstatic' name='cbMoodEcstatic' className='add-only' value='Ecstatic' /> Ecstatic</td>
                        <td className='w-250'><input type='checkbox' id='cbMoodDepressed' name='cbMoodDepressed' className='add-only' value='Depressed' /> Depressed</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbMoodGriefMourning' name='cbMoodGriefMourning' className='add-only' value='GriefMourning' /> Grief/Mourning</td>
                        <td className='w-250'><input type='checkbox' id='cbMoodAlexithymic' name='cbMoodAlexithymic' className='add-only' value='Alexithymic' /> Alexithymic</td>
                        <td className='w-250'><input type='checkbox' id='cbMoodElated' name='cbMoodElated' className='add-only' value='Elated' /> Elated</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbMoodHypomanic' name='cbMoodHypomanic' className='add-only' value='Hypomanic' /> Hypomanic</td>
                        <td className='w-250'><input type='checkbox' id='cbMoodManic' name='cbMoodManic' className='add-only' value='Manic' /> Manic</td>
                        <td className='w-250'><input type='checkbox' id='cbMoodAnxious' name='cbMoodAnxious' className='add-only' value='Anxious' /> Anxious</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbMoodTense' name='cbMoodTense' className='add-only' value='Tense' /> Tense</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbMoodOtherDescribe' name='cbMoodOtherDescribe' className='add-only' value='OtherDescribe' /> Other/Describe:
                            <input type='text' id='txtMoodOtherDescribe' name='txtMoodOtherDescribe' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>f. AFFECT</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAffectAppropriate' name='cbAffectAppropriate' className='add-only' value='Appropriate' /> Appropriate</td>
                        <td className='w-250'><input type='checkbox' id='cbAffectInappropriate' name='cbAffectInappropriate' className='add-only' value='Inappropriate' /> Inappropriate</td>
                        <td className='w-250'><input type='checkbox' id='cbAffectBlunted' name='cbAffectBlunted' className='add-only' value='Blunted' /> Blunted</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAffectRestricted' name='cbAffectRestricted' className='add-only' value='Restricted' /> Restricted</td>
                        <td className='w-250'><input type='checkbox' id='cbAffectFlat' name='cbAffectFlat' className='add-only' value='Flat' /> Flat</td>
                        <td className='w-250'><input type='checkbox' id='cbAffectLabile' name='cbAffectLabile' className='add-only' value='Labile' /> Labile</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAffectTearful' name='cbAffectTearful' className='add-only' value='Tearful' /> Tearful</td>
                        <td className='w-250'><input type='checkbox' id='cbAffectIntense' name='cbAffectIntense' className='add-only' value='Intense' /> Intense</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbAffectOtherDescribe' name='cbAffectOtherDescribe' className='add-only' value='OtherDescribe' /> Other/Describe:
                            <input type='text' id='txtAffectOtherDescribe' name='txtAffectOtherDescribe' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>g. PERCEPTUAL DISTURBANCES</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPerceptualDisturbamcesNone' name='cbPerceptualDisturbamcesNone' className='add-only' value='None' /> None</td>
                        <td className='w-250'><input type='checkbox' id='cbPerceptualDisturbamcesHallucinations' name='cbPerceptualDisturbamcesHallucinations' className='add-only' value='Hallucinations' /> Hallucinations</td>
                        <td className='w-250'><input type='checkbox' id='cbPerceptualDisturbamcesAuditory' name='cbPerceptualDisturbamcesAuditory' className='add-only' value='Auditory' /> Auditory</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPerceptualDisturbamcesVisual' name='cbPerceptualDisturbamcesVisual' className='add-only' value='Visual' /> Visual</td>
                        <td className='w-250'><input type='checkbox' id='cbPerceptualDisturbamcesOlfactory' name='cbPerceptualDisturbamcesOlfactory' className='add-only' value='Olfactory' /> Olfactory</td>
                        <td className='w-250'><input type='checkbox' id='cbPerceptualDisturbamcesTactile' name='cbPerceptualDisturbamcesTactile' className='add-only' value='Tactile' /> Tactile</td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPerceptualDisturbamcesOtherDescribe' name='cbPerceptualDisturbamcesOtherDescribe' className='add-only' value='OtherDescribe' /> Other/Describe:
                            <input type='text' id='txtPerceptualDisturbamcesOtherDescribe' name='txtPerceptualDisturbamcesOtherDescribe' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>h. THOUGHT PROCESS</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbThoughtProcessLogicalCoherent' name='cbThoughtProcessLogicalCoherent' className='add-only' value='LogicalCoherent' /> Logical/Coherent</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtProcessIncomprehensible' name='cbThoughtProcessIncomprehensible' className='add-only' value='Incomprehensible' /> Incomprehensible</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtProcessIncoherent' name='cbThoughtProcessIncoherent' className='add-only' value='Incoherent' /> Incoherent</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbThoughtProcessFlightIdeas' name='cbThoughtProcessFlightIdeas' className='add-only' value='FlightIdeas' /> Flight of Ideas</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtProcessLooseAssociations' name='cbThoughtProcessLooseAssociations' className='add-only' value='LooseAssociations' /> Loose Associations</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtProcessTangential' name='cbThoughtProcessTangential' className='add-only' value='Tangential' /> Tangential</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbThoughtProcessCircumstantial' name='cbThoughtProcessCircumstantial' className='add-only' value='Circumstantial' /> Circumstantial</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtProcessRambling' name='cbThoughtProcessRambling' className='add-only' value='Rambling' /> Rambling</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtProcessEvasive' name='cbThoughtProcessEvasive' className='add-only' value='Evasive' /> Evasive</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbThoughtProcessRacingThoughts' name='cbThoughtProcessRacingThoughts' className='add-only' value='RacingThoughts' /> Racing Thoughts</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtProcessPerseveration' name='cbThoughtProcessPerseveration' className='add-only' value='Perseveration' /> Perseveration</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtProcessThoughtBlocking' name='cbThoughtProcessThoughtBlocking' className='add-only' value='ThoughtBlocking' /> Thought Blocking</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbThoughtProcessConcrete' name='cbThoughtProcessConcrete' className='add-only' value='Concrete' /> Concrete</td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbThoughtProcessOtherDescribe' name='cbThoughtProcessOtherDescribe' className='add-only' value='OtherDescribe' /> Other/Describe:
                            <input type='text' id='txtThoughtProcessOtherDescribe' name='txtThoughtProcessOtherDescribe' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>i. THOUGHT CONTENT</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbThoughtContentPreoccupations' name='cbThoughtContentPreoccupations' className='add-only' value='Preoccupations' /> Preoccupations</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtContentObsessions' name='cbThoughtContentObsessions' className='add-only' value='Obsessions' /> Obsessions</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtContentCompulsions' name='cbThoughtContentCompulsions' className='add-only' value='Compulsions' /> Compulsions</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbThoughtContentPhobias' name='cbThoughtContentPhobias' className='add-only' value='Phobias' /> Phobias</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtContentDelusions' name='cbThoughtContentDelusions' className='add-only' value='Delusions' /> Delusions</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtContentThoughtBroadcasting' name='cbThoughtContentThoughtBroadcasting' className='add-only' value='ThoughtBroadcasting' /> Thought Broadcasting</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbThoughtContentThoughtInsertion' name='cbThoughtContentThoughtInsertion' className='add-only' value='ThoughtInsertion' /> Thought Insertion</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtContentThoughtWithdrawal' name='cbThoughtContentThoughtWithdrawal' className='add-only' value='ThoughtWithdrawal' /> Thought Withdrawal</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtContentIdeasReference' name='cbThoughtContentIdeasReference' className='add-only' value='IdeasReference' /> Ideas of Reference</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbThoughtContentIdeasInfluence' name='cbThoughtContentIdeasInfluence' className='add-only' value='IdeasInfluence' /> Ideas of Influence</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtContentDelusions_2' name='cbThoughtContentDelusions_2' className='add-only' value='Delusions' />  Delusions</td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbThoughtContentOtherDescribe' name='cbThoughtContentOtherDescribe' className='add-only' value='OtherDescribe' /> Other/Describe:
                            <input type='text' id='txtThoughtContentOtherDescribe' name='txtThoughtContentOtherDescribe' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>j. SUICIDAL/HOMICIDAL IDEATION</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbIdeationSuicidalThoughts' name='cbIdeationSuicidalThoughts' className='add-only' value='SuicidalThoughts' /> Suicidal Thoughts</td>
                        <td className='w-250'><input type='checkbox' id='cbIdeationSuicidalAttempts' name='cbIdeationSuicidalAttempts' className='add-only' value='SuicidalAttempts' /> Suicidal Attempts</td>
                        <td className='w-250'><input type='checkbox' id='cbIdeationSuicidalIntent' name='cbIdeationSuicidalIntent' className='add-only' value='SuicidalIntent' /> Suicidal Intent</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbIdeationSuicidalPlans' name='cbIdeationSuicidalPlans' className='add-only' value='SuicidalPlans' /> Suicidal Plans</td>
                        <td className='w-250'><input type='checkbox' id='cbIdeationHistoryBehavior' name='cbIdeationHistoryBehavior' className='add-only' value='HistoryBehavior' /> History of Self-Injurious Behavior</td>
                        <td className='w-250'><input type='checkbox' id='cbIdeationHomicidalThoughts' name='cbIdeationHomicidalThoughts' className='add-only' value='HomicidalThoughts' /> Homicidal Thoughts</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbIdeationHomicidalAttempts' name='cbIdeationHomicidalAttempts' className='add-only' value='HomicidalAttempts' /> Homicidal Attempts </td>
                        <td className='w-250'><input type='checkbox' id='cbIdeationHomicidalIntent' name='cbIdeationHomicidalIntent' className='add-only' value='HomicidalIntent' /> Homicidal Intent</td>
                        <td className='w-250'><input type='checkbox' id='cbIdeationHomicidalPlans' name='cbIdeationHomicidalPlans' className='add-only' value='HomicidalPlans' /> Homicidal Plans</td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbIdeationOtherDescribe' name='cbIdeationOtherDescribe' className='add-only' value='OtherDescribe' /> Other/Describe:
                            <input type='text' id='txtIdeationOtherDescribe' name='txtIdeationOtherDescribe' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>k. SENSORIUM/COGNITION</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSensoriumAlert' name='cbSensoriumAlert' className='add-only' value='Alert' /> Alert</td>
                        <td className='w-250'><input type='checkbox' id='cbSensoriumLethargic' name='cbSensoriumLethargic' className='add-only' value='Lethargic' /> Lethargic</td>
                        <td className='w-250'><input type='checkbox' id='cbSensoriumSomnolent' name='cbSensoriumSomnolent' className='add-only' value='Somnolent' /> Somnolent</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSensoriumStuporous' name='cbSensoriumStuporous' className='add-only' value='Stuporous' /> Stuporous</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Oriented to:</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbOrientedToPerson' name='cbOrientedToPerson' className='add-only' value='Person' /> Person</td>
                        <td className='w-250'><input type='checkbox' id='cbOrientedToPlace' name='cbOrientedToPlace' className='add-only' value='Place' />  Place</td>
                        <td className='w-250'><input type='checkbox' id='cbOrientedToTime' name='cbOrientedToTime' className='add-only' value='Time' /> Time</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbOrientedToSituation' name='cbOrientedToSituation' className='add-only' value='Situation' /> Situation</td>
                        <td className='w-250'><input type='checkbox' id='cbOrientedToNormalConcentration' name='cbOrientedToNormalConcentration' className='add-only' value='NormalConcentration' /> Normal Concentration</td>
                        <td className='w-250'><input type='checkbox' id='cbOrientedToImpairedConcentration' name='cbOrientedToImpairedConcentration' className='add-only' value='ImpairedConcentration' /> Impaired Concentration</td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOrientedToOtherDescribe' name='cbOrientedToOtherDescribe' className='add-only' value='OtherDescribe' /> Other/Describe:
                            <input type='text' id='txtOrientedToOtherDescribe' name='txtOrientedToOtherDescribe' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>

                </table>

                <p className='w-750'><h3>l. MEMORY</h3></p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Remote Memory:</span></td>
                        <td className='w-375'><span className='eleHeader'>Recent Memory:</span></td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbRemoteMemoryNormal' name='rbRemoteMemory' className='add-only' value='Normal' /> Normal &nbsp;
                            <input type='radio' id='rbRemoteMemoryImpaired' name='rbRemoteMemory' className='add-only' value='Impaired' /> Impaired
                        </td>

                        <td className='w-375'>
                            <input type='radio' id='rbRecentMemoryNormal' name='rbRecentMemory' className='add-only' value='Normal' /> Normal &nbsp;
                            <input type='radio' id='rbRecentMemoryImpaired' name='rbRecentMemory' className='add-only' value='Impaired' /> Impaired
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'><span className='eleHeader'>Immediate Recall:</span></td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbImmediateRecallNormal' name='rbImmediateRecall' className='add-only' value='Normal' /> Normal &nbsp;
                            <input type='radio' id='rbImmediateRecallImpaired' name='rbImmediateRecall' className='add-only' value='Impaired' /> Impaired
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbMemoryOtherDescribe' name='cbMemoryOtherDescribe' className='add-only' value='OtherDescribe' /> Other/Describe:
                            <input type='text' id='txtMemoryOtherDescribe' name='txtMemoryOtherDescribe' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>m. INTELLECTUAL FUNCTIONING</span><span className='small'>(Estimate)</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='radio' id='rbIntellectualFunctioningAboveAvg' name='rbIntellectualFunctioning' className='add-only' value='AboveAvg' /> Above Avg</td>
                        <td className='w-250'><input type='radio' id='rbIntellectualFunctioningNormalAvg' name='rbIntellectualFunctioning' className='add-only' value='NormalAvg' /> Normal/Avg</td>
                        <td className='w-250'><input type='radio' id='rbIntellectualFunctioningBorderline' name='rbIntellectualFunctioning' className='add-only' value='Borderline' /> Borderline</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Mental Retardation:</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='radio' id='rbMentalRetardationMild' name='rbMentalRetardation' className='add-only' value='Mild' /> Mild</td>
                        <td className='w-250'><input type='radio' id='rbMentalRetardationModerate' name='rbMentalRetardation' className='add-only' value='Moderate' /> Moderate</td>
                        <td className='w-250'><input type='radio' id='rbMentalRetardationSevere' name='rbMentalRetardation' className='add-only' value='Severe' /> Severe</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='radio' id='rbMentalRetardatioOtherDescribe' name='rbMentalRetardation' className='add-only' value='OtherDescribe' /> Other/Describe:
                            <input type='text' id='txtMentalRetardationOtherDescribe' name='txtMentalRetardationOtherDescribe' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>n. JUDGEMENT</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='radio' id='rbJudgementCriticalJudgementIntact' name='rbJudgement' className='add-only' value='CriticalJudgementIntact' /> Critical Judgement Intact</td>
                        <td className='w-250'><input type='radio' id='rbJudgementImpairedJudgement' name='rbJudgement' className='add-only' value='ImpairedJudgement' /> Impaired Judgement</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='radio' id='rbJudgementOtherDescribe' name='rbJudgement' className='add-only' value='OtherDescribe' /> Other/Describe:
                            <input type='text' id='txtJudgementOtherDescribe' name='txtJudgementOtherDescribe' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>o. INSIGHT</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='radio' id='rbInsightTrueEmotionalInsight' name='rbInsight' className='add-only' value='TrueEmotionalInsight' /> True Emotional Insight</td>
                        <td className='w-250'><input type='radio' id='rbInsightIntellectualInsight' name='rbInsight' className='add-only' value='IntellectualInsight' /> Intellectual Insight</td>
                        <td className='w-250'><input type='radio' id='rbInsightImpairedInsight' name='rbInsight' className='add-only' value='ImpairedInsight' /> Impaired Insight</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbInsightDenial' name='rbInsight' className='add-only' value='Denial' /> Denial</td>
                        <td className='w-500'><input type='radio' id='rbInsightSomeAwarenessIllnessSymptoms' name='rbInsight' className='add-only' value='SomeAwarenessIllnessSymptoms' /> Some Awareness of Illness/Symptoms</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='radio' id='rbInsightOtherDescribe' name='rbInsight' className='add-only' value='OtherDescribe' /> Other/Describe:
                            <input type='text' id='txtInsightOtherDescribe' name='txtInsightOtherDescribe' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>p. IMPULSE CONTROL</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='radio' id='rbImpulseControlAbleResistImpulses' name='rbImpulseControl' className='add-only' value='AbleResistImpulses' /> Able to Resist Impulses</td>
                        <td className='w-250'><input type='radio' id='rbImpulseControlRecentImpulsiveBehavior' name='rbImpulseControl' className='add-only' value='RecentImpulsiveBehavior' /> Recent Impulsive Behavior</td>
                        <td className='w-250'><input type='radio' id='rbImpulseControlImpairedImpulseControl' name='rbImpulseControl' className='add-only' value='ImpairedImpulseControl' /> Impaired Impulse Control</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbImpulseControlCompulsions' name='rbImpulseControl' className='add-only' value='Compulsions' /> Compulsions</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='radio' id='rbImpulseControltOtherDescribe' name='rbImpulseControl' className='add-only' value='OtherDescribe' /> Other/Describe:
                            <input type='text' id='txtImpulseControlOtherDescribe' name='txtImpulseControlOtherDescribe' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>II. RISK ASSESSMENT:</h3>
                    <span className='small'>Assess potential risk of harm to self or others, including patterns of risk behavior and/or risk due to personality factors, substance use, criminogenic factors, exposure to elements, exploitation, abuse, neglect, suicidal or homicidal history, self-injury, psychosis, impulsiveness,etc.</span>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>a. Risk of Harm to Self:</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRiskSelfHarmPriorSuicideAttempt' name='cbRiskSelfHarmPriorSuicideAttempt' className='add-only' value='PriorSuicideAttempt' /> Prior Suicide Attempt</td>
                        <td className='w-250'><input type='checkbox' id='cbRiskSelfHarmStartedPlanIntent' name='cbRiskSelfHarmStartedPlanIntent' className='add-only' value='StartedPlanIntent' /> Started/Plan/Intent</td>
                        <td className='w-250'><input type='checkbox' id='cbRiskSelfHarmRecentLoss' name='cbRiskSelfHarmRecentLoss' className='add-only' value='RecentLoss' /> Recent Loss</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRiskSelfHarmTerminalIllness' name='cbRiskSelfHarmTerminalIllness' className='add-only' value='TerminalIllness' /> Terminal Illness</td>
                        <td className='w-250'><input type='checkbox' id='cbRiskSelfHarmSubstanceAbuse' name='cbRiskSelfHarmSubstanceAbuse' className='add-only' value='SubstanceAbuse' /> Substance Abuse</td>
                        <td className='w-250'><input type='checkbox' id='cbRiskSelfHarmMarkedLackSupport' name='cbRiskSelfHarmMarkedLackSupport' className='add-only' value='MarkedLackSupport' /> Marked Lack of Support</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRiskSelfHarmPsychosis' name='cbRiskSelfHarmPsychosis' className='add-only' value='Psychosis' /> Psychosis</td>
                        <td className='w-250'><input type='checkbox' id='cbRiskSelfHarmSuicideFriendacquaintance' name='cbRiskSelfHarmSuicideFriendacquaintance' className='add-only' value='SuicideFriendacquaintance' /> Suicide of friend/acquaintance</td>
                        <td className='w-250'><input type='checkbox' id='cbRiskSelfHarmFamilyHistorySuicide' name='cbRiskSelfHarmFamilyHistorySuicide' className='add-only' value='FamilyHistorySuicide' /> Family history of Suicide</td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbRiskSelfHarmPresenceBehavioralCues' name='cbRiskSelfHarmPresenceBehavioralCues' className='add-only' value='PresenceBehavioralCues' /> Presence of Behavioral Cues (isolation, giving away possessions, rapid mood swings etc)</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbRiskSelfHarmAccessMeans' name='cbRiskSelfHarmAccessMeans' className='add-only' value='AccessMeans' /> Access to means (weapons,pills,etc)</td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbRiskSelfHarmOtherDescribe' name='cbRiskSelfHarmOtherDescribe' className='add-only' value='OtherDescribe' /> Other/Describe:
                            <input type='text' id='txtRiskSelfHarmOtherDescribe' name='txtRiskSelfHarmOtherDescribe' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>b. Risk of Harm to Others:</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRiskHarmSelfPriorActsViolence' name='cbRiskHarmSelfPriorActsViolence' className='add-only' value='PriorActsViolence' /> Prior acts of Violence</td>
                        <td className='w-250'><input type='checkbox' id='cbRiskHarmSelfDestructionProperty' name='cbRiskHarmSelfDestructionProperty' className='add-only' value='DestructionProperty' /> Destruction of Property</td>
                        <td className='w-250'><input type='checkbox' id='cbRiskHarmSelfArrestViolence' name='cbRiskHarmSelfArrestViolence' className='add-only' value='ArrestViolence' /> Arrest for Violence</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRiskHarmSelfAccessMeans' name='cbRiskHarmSelfAccessMeans' className='add-only' value='AccessMeans' /> Access to means (weapons)</td>
                        <td className='w-250'><input type='checkbox' id='cbRiskHarmSelfSubstance' name='cbRiskHarmSelfSubstance' className='add-only' value='Substance' /> Substance use</td>
                        <td className='w-250'><input type='checkbox' id='cbRiskHarmSelfPhysicallyAbusedAsChild' name='cbRiskHarmSelfPhysicallyAbusedAsChild' className='add-only' value='PhysicallyAbused' /> Physically Abused as a child</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRiskHarmSelfWasPhysicallyAbusive' name='cbRiskHarmSelfWasPhysicallyAbusive' className='add-only' value='WasPhysicallyAbusive' /> Was physically abusive as a child</td>
                        <td className='w-250'><input type='checkbox' id='cbRiskHarmSelfHarmsAnimals' name='cbRiskHarmSelfHarmsAnimals' className='add-only' value='HarmsAnimals' /> Harms animals</td>
                        <td className='w-250'><input type='checkbox' id='cbRiskHarmSelfFireSetting' name='cbRiskHarmSelfFireSetting' className='add-only' value='FireSetting' /> Fire Setting</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRiskHarmSelfAngryMoodAgitation' name='cbRiskHarmSelfAngryMoodAgitation' className='add-only' value='AngryMoodAgitation' /> Angry mood/agitation</td>
                        <td className='w-500'><input type='checkbox' id='cbRiskHarmSelfPsychosisHallucinations' name='cbRiskHarmSelfPsychosisHallucinations' className='add-only' value='PsychosisHallucinations' /> Psychosis/command hallucinations</td>

                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbRiskHarmSelfPriorHospitalizations' name='cbRiskHarmSelfPriorHospitalizations' className='add-only' value='PriorHospitalizations' /> Prior hospitalizations for danger to others</td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Summary of Risk Evaluation:</span></p>
                <p className='w-750'>
                    <input type='radio' id='rbRiskEvaluationNone' name='rbRiskEvaluation' className='add-only' value='None' /> None &nbsp;
                    <input type='radio' id='rbRiskEvaluationLow' name='rbRiskEvaluation' className='add-only' value='Low' /> Low &nbsp;
                    <input type='radio' id='rbRiskEvaluationModerate' name='rbRiskEvaluation' className='add-only' value='Moderate' /> Moderate &nbsp;
                    <input type='radio' id='rbRiskEvaluationImminent' name='rbRiskEvaluation' className='add-only' value='Imminent' /> Imminent
                </p>

                <p className='w-750'><span className='eleHeader'>DIAGNOSTIC IMPRESSIONS:</span></p>
                <p className='w-750'>
                    <textarea id='txtDiagnosisImpression' name='txtDiagnosisImpression' className='add-only'></textarea>
                </p>



                <p className='w-750'>TREATMENT PLAN: <span className='small'>(Illness and symptoms management specific to):</span></p>

                <p className='w-750'>
                    <input type='checkbox' id='cbAdhd' name='cbAdhd' className='add-only' value='Adhd' /> <b>ADHD :</b> Hyperactivity, impulse control, focus/concentration
                </p>



                <p className='w-750'>
                    <input type='checkbox' id='cbOdd' name='cbOdd' className='add-only' value='Odd' /> <b>ODD :</b> Aggression, impulse control
                </p>



                <p className='w-750'>
                    <input type='checkbox' id='cbExplosiveDisorder' name='cbExplosiveDisorder' className='add-only' value='ExplosiveDisorder' /> <b>Intermittent Explosive Disorder/Disruptive Impulse Control :</b> anger, aggression, impulse control, depression
                </p>



                <p className='w-750'>
                    <input type='checkbox' id='cbConductDisorder' name='cbConductDisorder' className='add-only' value='ConductDisorder' /> <b>Conduct Disorder :</b> Aggression, anger, impulse contro
                </p>



                <p className='w-750'>
                    <input type='checkbox' id='cbDepressiveDisorder' name='cbDepressiveDisorder' className='add-only' value='DepressiveDisorder' /> <b>Depressive Disorders :</b> Mood regulation
                </p>



                <p className='w-750'>
                    <input type='checkbox' id='cbMoodDysregulationDisorder' name='cbMoodDysregulationDisorder' className='add-only' value='MoodDysregulationDisorder' /> <b>Mood Dysregulation Disorder :</b> Mood regulation
                </p>



                <p className='w-750'>
                    <input type='checkbox' id='cbPhobiaDisorder' name='cbPhobiaDisorder' className='add-only' value='PhobiaDisorder' /> <b>Anxiety & Phobia related disorders :</b> Irritability, concentration, restlessness, anxiousness
                </p>



                <p className='w-750'>
                    <input type='checkbox' id='cbPtsd' name='cbPtsd' className='add-only' value='Ptsd' /> <b>PTSD & other trauma related disorders :</b> Agitation, irritability, hypervigilance, anxiety
                </p>



                <p className='w-750'>
                    <input type='checkbox' id='cbBipolar' name='cbBipolar' className='add-only' value='Bipolar' /> <b>Bipolar :</b> Mania & Mood stabilization
                </p>



                <p className='w-750'>
                    <input type='checkbox' id='cbPsychoticdisorders' name='cbPsychoticdisorders' className='add-only' value='Psychoticdisorders' /> <b>Schizophrenia Spectrum & Other psychotic disorders :</b> Psychosis stabilization
                </p>



                <p className='w-750'>
                    <input type='checkbox' id='cbOcd' name='cbOcd' className='add-only' value='Ocd' /> <b>OCD :</b> Agitation, hypervigilance, fear, compulsions, rumination & anxiousness
                </p>



                <p className='w-750'>
                    <input type='checkbox' id='cbSubstanceRelatedDisorder' name='cbSubstanceRelatedDisorder' className='add-only' value='SubstanceRelatedDisorder' /> <b>Substance Related Disorders: (Referral information)</b>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Recommended Services:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRecommendedServicesCpst' name='cbRecommendedServicesCpst' className='add-only' value='Cpst' /> CPST</td>
                        <td className='w-250'><input type='checkbox' id='cbRecommendedServicesPsr' name='cbRecommendedServicesPsr' className='add-only' value='Psr' /> PSR</td>
                        <td className='w-250'><input type='checkbox' id='cbRecommendedServicesMedicationManagement' name='cbRecommendedServicesMedicationManagement' className='add-only' value='MedicationManagement' /> Medication Management</td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Frequency</span></td>
                        <td className='w-250'><span className='eleHeader'>Amount</span></td>
                        <td className='w-250'><span className='eleHeader'>Duration</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='text' id='txtFrequency_1' name='txtFrequency_1' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtAmount_1' name='txtAmount_1' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtDuration_1' name='txtDuration_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='text' id='txtFrequency_2' name='txtFrequency_2' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtAmount_2' name='txtAmount_2' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtDuration_2' name='txtDuration_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecommendedServicesOther' name='cbRecommendedServicesOther' /> Other (Specify):
                            <input type='text' id='txtRecommendedServicesOther' name='txtRecommendedServicesOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><h3>New Medication (s) prescribed:</h3></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Name of medication</span></td>
                        <td className='w-250'><span className='eleHeader'>Dose/Strength</span></td>
                        <td className='w-250'><span className='eleHeader'>What is this medication used to treat</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='text' id='txtMedicationName_1' name='txtMedicationName_1' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtDoseStrength_1' name='txtDoseStrength_1' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtMedicationToTreat_1' name='txtMedicationToTreat_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='text' id='txtMedicationName_2' name='txtMedicationName_2' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtDoseStrength_2' name='txtDoseStrength_2' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtMedicationToTreat_2' name='txtMedicationToTreat_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='text' id='txtMedicationName_3' name='txtMedicationName_3' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtDoseStrength_3' name='txtDoseStrength_3' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtMedicationToTreat_3' name='txtMedicationToTreat_3' className='add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Psychiatrist Signature </td>
                        <td className='small w-250'> &nbsp;Date</td>
                    </tr>
                </table>

                <p className='w-750'>Follow-up Plan/Return Date:</p>
                <p className='750'>
                    <input type='date' id='txtFollowUpDate' name='txtFollowUpDate' className='add-only w-250 custom-add-only' />
                </p>





            </div>
        </form>

    )
}







